import { render, staticRenderFns } from "./Gauge.vue?vue&type=template&id=2ca23c2b&scoped=true"
import script from "./Gauge.vue?vue&type=script&lang=js"
export * from "./Gauge.vue?vue&type=script&lang=js"
import style0 from "./Gauge.vue?vue&type=style&index=0&id=2ca23c2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca23c2b",
  null
  
)

export default component.exports